interface BrandLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  wordmarkClassName?: string;
}

export function BrandLogo({
  className = '',
  size = 'md',
  showWordmark = true,
  wordmarkClassName = '',
}: BrandLogoProps) {
  const sizeMap = {
    sm: { iconSize: 20, textClass: 'text-base font-bold' },
    md: { iconSize: 28, textClass: 'text-xl font-bold' },
    lg: { iconSize: 38, textClass: 'text-2xl font-extrabold' },
  };

  const { iconSize, textClass } = sizeMap[size] || sizeMap.md;

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      {/* Temporary TradeFluency Brand Mark */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0 transition-transform duration-200 group-hover:scale-105"
      >
        <defs>
          <linearGradient id="tf-gradient-primary" x1="2" y1="4" x2="34" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="50%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
          <linearGradient id="tf-gradient-accent" x1="12" y1="6" x2="28" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#22d3ee" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>

        {/* Outer squircle/badge */}
        <rect
          x="1"
          y="1"
          width="34"
          height="34"
          rx="9"
          fill="#0c111d"
          stroke="url(#tf-gradient-primary)"
          strokeWidth="1.5"
        />

        {/* Dynamic Fluent Chevron / T-F Bars */}
        {/* Left vertical bar */}
        <rect x="7.5" y="10" width="3.5" height="16" rx="1.75" fill="url(#tf-gradient-primary)" />
        {/* Horizontal top bar */}
        <path
          d="M7.5 11.5C7.5 10.67 8.17 10 9 10H22C22.83 10 23.5 10.67 23.5 11.5V12C23.5 12.83 22.83 13.5 22 13.5H9C8.17 13.5 7.5 12.83 7.5 12V11.5Z"
          fill="url(#tf-gradient-primary)"
        />
        {/* Ascending fluency pulse / trend arrow */}
        <path
          d="M15 22.5L20 17.5L24 20.5L28.5 14"
          stroke="url(#tf-gradient-accent)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="28.5" cy="14" r="2" fill="#38bdf8" />
      </svg>

      {showWordmark && (
        <span
          className={`tracking-tight bg-gradient-to-r from-white via-slate-100 to-slate-300 bg-clip-text text-transparent font-bold ${textClass} ${wordmarkClassName}`}
        >
          TradeFluency
        </span>
      )}
    </div>
  );
}

export default BrandLogo;
